/**
 * @file 聚合页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_ACTIVITY_GET_SERVICE, GET_INSTANCE_GETINSTANCE, GET_APIMEAL_PAY, GET_GET_NEW_SERVICE} from './ActionTypes';

export function fetchActivityGetService(dispatch, obj) {
    return rcAjax('GET', '/xiapi/api/v1/activity/getService', obj, {}, data => {
        dispatch({type: GET_ACTIVITY_GET_SERVICE, data: data.data});
    });
}

export function fetchInstanceGetInstance(dispatch) {
    return rcAjax('GET', '/xiapi/api/v1/instance/getInstance', {}, {}, data => {
        dispatch({type: GET_INSTANCE_GETINSTANCE, data: data.data});
    });
}

export function fetchApimealPay(dispatch, obj) {
    return rcAjax('POST', '/xiapi/api/v1/gateway/apimeal/pay', {}, obj, data => {
        dispatch({type: GET_APIMEAL_PAY, data: data.data});
    });
}

export function fetchGetNewService(dispatch, obj) {
    return rcAjax('GET', '/xiapi/api/v1/activity/getNewService', obj, {}, data => {
        dispatch({type: GET_GET_NEW_SERVICE, data: data.data});
    });
}

export function fetchRealName(obj) {
    return rcAjax(
        'POST',
        '/xiapi/api/v1/gateway/apimeal/real_name',
        {},
        obj,
        () => null
    ).then(data => data.data);
}

export function fetchPayInfo(obj) {
    return rcAjax(
        'GET',
        '/xiapi/api/v1/gateway/apimeal/getActivityService',
        obj,
        {},
        () => null
    ).then(data => data.data);
}



// WEBPACK FOOTER //
// ./src/actions/buyAction.js